import { render, staticRenderFns } from "./cardOpen.vue?vue&type=template&id=40fd0546&scoped=true&"
import script from "./cardOpen.vue?vue&type=script&lang=js&"
export * from "./cardOpen.vue?vue&type=script&lang=js&"
import style0 from "./cardOpen.vue?vue&type=style&index=0&id=40fd0546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fd0546",
  null
  
)

export default component.exports